import { createFileRoute } from "@tanstack/react-router"
import { lazy } from "react"
import LazyRoutePage from "../../../-LazyRoutePage"

const ProductPage = lazy(
  () => import("../../../../components/WMS/Products/ProductPage.tsx"),
)

export const Route = createFileRoute("/_layout/WMS/products/$product")({
  component: ProductRoute,
})

function ProductRoute() {
  return (
    <LazyRoutePage>
      <ProductPage />
    </LazyRoutePage>
  )
}
